import getApiClient from "./../../../../shared/api";
import { showInfo, showError, clearNotifications } from "./../../../../notifications/ducks/actions";

export const IMPORT_BACKGROUND_ACTORS = "IMPORT_BACKGROUND_ACTORS";
export const IMPORT_BACKGROUND_ACTORS_CLEAR_REDIRECT = "IMPORT_BACKGROUND_ACTORS_CLEAR_REDIRECT";

export function copyBackgroundActors(filmId, otherFilmId, sameFilm) {

  return (dispatch) => {
    dispatch({
      type: IMPORT_BACKGROUND_ACTORS,
      payload: getApiClient().post(`/film/${filmId}/BackgroundActor/Copy`, { otherFilmId, sameFilm }),
      meta: {},
    })
      .then((response) => {
        dispatch(showInfo(`Copied actors`));
      })
      .catch((response) => {
        dispatch(showError(`Error copying actors`));
      })
      .then((response) => {
        dispatch(clearNotifications());
      });
  };
}


export function clearRedirect(dispatch) {
  return (dispatch) => {
    dispatch({
      type: IMPORT_BACKGROUND_ACTORS_CLEAR_REDIRECT,
    });
  };
}
